import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../api/firebase";

/**
 * shrineId → 表示用の名前・所在。visits には名前が無いので shrines/{id} から補う。
 * `known` に検索結果など手元にある分を渡すと、その分は読みに行かない。
 */
export default function useShrineNames(shrineIds, known = {}) {
  const [names, setNames] = useState({});
  const key = shrineIds.join("|");

  useEffect(() => {
    const ids = key ? key.split("|") : [];
    const missing = ids.filter((id) => !names[id] && !known[id]);
    if (!missing.length) return undefined;
    let alive = true;
    Promise.all(
      missing.map(async (id) => {
        try {
          const snap = await getDoc(doc(db, "shrines", id));
          const x = snap.exists() ? snap.data() : {};
          return [id, { shrineId: id, name: x.name || "", prefecture: x.prefecture || "", city: x.city || "" }];
        } catch (e) {
          return [id, { shrineId: id, name: "", prefecture: "", city: "" }];
        }
      })
    ).then((pairs) => {
      if (!alive) return;
      setNames((prev) => ({ ...prev, ...Object.fromEntries(pairs) }));
    });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { ...names, ...known };
}
